import React from "react";
import AppRoutes from "./routing/routes";
import "./App.css";

const App = () => {
    return (
        <>
            <AppRoutes />
        </>
    );
};

export default App;
